/**
 * features/posts 内部で共有する form 制約 + Tailwind utility 定数 (reviewer audit ⚠️ A 反映)。
 *
 * 旧 PostForm.tsx + PostDetailModal.tsx で独立に定義していた TITLE_MAX / COMMENT_MAX /
 * INPUT_CLASS / LABEL_CLASS / COUNTER_CLASS を 1 箇所に集約。Phase 5 後半の編集 UI 拡張
 * (location 再取得 / photo 差し替え) 時に値の乖離を防ぐ。
 */

export const TITLE_MAX = 100;
export const COMMENT_MAX = 1000;
export const NICKNAME_MAX = 40;

export const INPUT_CLASS =
  'w-full px-3 py-2 text-sm border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-600';
export const LABEL_CLASS = 'block text-xs text-slate-600 mb-1';
export const COUNTER_CLASS = 'text-[11px] text-slate-400 mt-0.5';
